import React from 'react';
import { Filter } from 'lucide-react';
import './StatusFilter.css';

export type ClientStatusFilter = 'all' | 'demo' | 'paid' | 'inactive' | 'terminated' | 'demo_terminated';

interface StatusFilterProps {
  selectedStatus: ClientStatusFilter;
  onStatusChange: (status: ClientStatusFilter) => void;
  demoCount: number;
  paidCount: number;
  inactiveCount: number;
  terminatedCount: number;
  demoTerminatedCount: number;
  totalCount: number;
}

const StatusFilter: React.FC<StatusFilterProps> = ({
  selectedStatus,
  onStatusChange,
  demoCount,
  paidCount,
  inactiveCount,
  terminatedCount,
  demoTerminatedCount,
  totalCount
}) => {
  const statusOptions = [
    { 
      value: 'all' as ClientStatusFilter, 
      label: 'Todos los Clientes', 
      count: totalCount,
      className: 'all'
    },
    { 
      value: 'demo' as ClientStatusFilter, 
      label: 'Demos', 
      count: demoCount,
      className: 'demo'
    },
    { 
      value: 'paid' as ClientStatusFilter, 
      label: 'Clientes Pago', 
      count: paidCount,
      className: 'paid'
    },
    { 
      value: 'inactive' as ClientStatusFilter, 
      label: 'Inactivos', 
      count: inactiveCount,
      className: 'inactive'
    },
    { 
      value: 'demo_terminated' as ClientStatusFilter, 
      label: 'Demo Terminado', 
      count: demoTerminatedCount,
      className: 'demo-terminated'
    },
    { 
      value: 'terminated' as ClientStatusFilter, 
      label: 'Terminado', 
      count: terminatedCount,
      className: 'terminated'
    }
  ];

  return (
    <div className="status-filter">
      <div className="status-filter-header">
        <Filter size={18} />
        <span>Filtrar por Estado:</span>
      </div>
      <div className="status-filter-options">
        {statusOptions.map((option) => (
          <button
            key={option.value}
            className={`status-filter-button ${option.className} ${
              selectedStatus === option.value ? 'active' : ''
            }`}
            onClick={() => onStatusChange(option.value)}
          >
            <span className="status-label">{option.label}</span>
            <span className="status-count">({option.count})</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default StatusFilter;